import React from "react";
import styles from "./Hero.module.css";
import videoBG from "./video.mp4";
import { Swiper, SwiperSlide } from "swiper/react";
import Header from "../Header/Header";
import { Autoplay } from "swiper/modules";
import { useNavigate } from "react-router-dom";

const partnerImages = [
  "/images/icons/partner-logo-1.png",
  "/images/icons/partner-logo-2.png",
  "/images/icons/partner-logo-3.png",
  "/images/icons/partner-logo-4.png",
  "/images/icons/partner-logo-5.png",
]

const Hero = () => {
  const navigate = useNavigate()
  return (
    <div>
    <div style={{position:"relative"}}>
        <div style={{position:"relative",zIndex:"10"}}>

        <Header fontDark={false}/> 
        </div>
        <video
          className={styles.video}
          src={videoBG}
          autoPlay={true}
          loop={true}
          muted={true}
          playsInline={true}
        />
      <div className={styles.Hero}>
        <div className={styles.overlay}></div>
        <div className="container mt-auto mb-5">

          <div className={[styles.Hero_Content]} >
            <h1 className={`hero-section-heading  text-center`} >
               Precision Built Surfaces
              </h1>
            <p className="body-paragraph color-light text-center mx-auto px-lg-5 mx-lg-5" >
           Durable, hygienic surface systems designed for modern commercial and healthcare environments.
            </p>
            {/* <button className="hero-genral-btn" 
            >View  Portfolio</button> */}
          </div>
        </div>
     
      </div>
    </div>
   
    </div>
  );
};

export default Hero;
